export default __webpack_public_path__ + "static/ab-footer-25c4bfc19a2f099b4e0a393ed9aeb18f.jpg";